import { useEffect, useMemo, useState } from "react";
import { ApiCall } from "../../../helper/axios";
import { useLocation } from "react-router-dom";
import moment from "moment";

const PER_PAGE = 9;

const sortOptions = [
  {
    key: "popular",
    val: "DESC",
    title: "Most Popular Products",
  },
  {
    key: "price",
    val: "ASC",
    title: "Price: Lowest to Highest",
  },
  {
    key: "price",
    val: "DESC",
    title: "Price: Highest to Lowest",
  },
  {
    key: "alphabatically",
    val: "ASC",
    title: "Alphabetically: A-Z",
  },
  {
    key: "alphabatically",
    val: "DESC",
    title: "Alphabetically: Z-A",
  },
];
export const getExcurstionList = () => {
  const location = useLocation()
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortFilter, setSortFilter] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [sortBy, setSortBy] = useState(sortOptions[0]);
  const [page, setPage] = useState(1);


  useEffect(() => {
    if (location.state?.selectedCategory) {
      setSelectedCategory(location.state.selectedCategory);
    } else {
      setSelectedCategory({})
    }
  }, [location.state]);

  const refresh = async () => {
    try {
      setLoading(true);
      const searchParams = new URLSearchParams(location.search);
      const cityId = searchParams.get("city-id") || "";
      const countryId = searchParams.get("country-id") || "";
      const travelDateParam = searchParams.get("travel-date");
      const parsedTravelDate = moment(travelDateParam, "DD-MM-YYYY", true);
      const travelDate = parsedTravelDate.isValid()
        ? parsedTravelDate.format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY");

      const list = await ApiCall(
        "POST",
        `/excursions/search`,
        { countryId, cityId, travelDate },
        {}
      );
      const responseData = Array.isArray(list?.data)
        ? list?.data
        : Array.isArray(list?.data?.data)
          ? list?.data?.data
          : []

      setData(responseData);
      setShowLoadMore((responseData?.length) > PER_PAGE);
    } catch (error) {
      setData([])
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [location.search]);

  const allOptions = useMemo(() => {
    if(data && data?.length && Array.isArray(data)){
      return data?.map((d) => ({
        label: d?.excursionTitle,
        value: d?.excursionId?.toString(),
        slug: d?.excursionSlug,
        img: d?.excursionThumbnail,
        excursion: d,
      }));
    }
    return [];
  }, [data]);

  const categoryOptions = useMemo(() => {
    if (!Array.isArray(data)) return [];
    const unique = new Map();
    data.forEach((item) => {
      item?.excursionCatagories?.forEach?.((cat) => {
        const name = cat?.taxonomyName;
        if (name == null || String(name).trim() === "") return;
        const key = String(name).trim().toLowerCase();
        if (!unique.has(key)) {
          unique.set(key, {
            catId: key,
            catName: cat?.taxonomyName,
            catSlug: cat?.taxonomySlug,
          });
        }
      });
    });
    return Array.from(unique.values()).sort((a, b) =>
      String(a?.catName ?? "").localeCompare(String(b?.catName ?? ""))
    );
  }, [data]);

  const {
    filteredData: finalData,
    totalFiltered,
  } = useMemo(() => {
    if (!Array.isArray(data)) return { filteredData: [], totalFiltered: 0 };

    let list = [...data];
    list = list?.filter(
      (d) => d?.excursionPrice?.adultPrice && d?.excursionPrice?.adultPrice > 0
    );
    if (selectedCategory?.catId && selectedCategory?.catId !== "all") {
      list = list?.filter((d) =>
        d?.excursionCatagories?.some(
          (c) => String(c?.taxonomyName).trim().toLowerCase() === String(selectedCategory?.catId).trim().toLowerCase()
        )
      );
    }

    const totalCount = list?.length;

    if (sortBy.key === "price") {
      list.sort((a, b) =>
        sortBy.val === "ASC"
          ? a.excursionPrice.adultPrice - b.excursionPrice.adultPrice
          : b.excursionPrice.adultPrice - a.excursionPrice.adultPrice
      );
    }

    if (sortBy.key === "alphabatically") {
      list.sort((a, b) =>
        sortBy.val === "ASC"
          ? a.excursionTitle.toLowerCase().localeCompare(b.excursionTitle.toLowerCase())
          : b.excursionTitle.toLowerCase().localeCompare(a.excursionTitle.toLowerCase())
      );
    }

    if (sortBy.key === "popular") {
      const popularData = list.filter((d) => d?.popularProducts);
      const normalData = list.filter((d) => !d?.popularProducts);

      popularData.sort(
        (a, b) =>
          parseInt(a?.popularProducts || 0) -
          parseInt(b?.popularProducts || 0)
      );

      normalData.sort(
        (a, b) =>
          parseInt(b?.noOfTickets || 0) - parseInt(a?.noOfTickets || 0)
      );

      list = [...popularData, ...normalData];
    }

    const paginated = list.slice(0, page * PER_PAGE);

    return {
      filteredData: paginated,
      totalFiltered: totalCount,
    };
  }, [data, selectedCategory, sortBy, page]);

  useEffect(() => {
    if (totalFiltered > page * PER_PAGE) {
      setShowLoadMore(true);
    } else {
      setShowLoadMore(false);
    }
  }, [totalFiltered, page]);

  return {
    refresh,
    data: finalData,
    loading,
    sortFilter,
    setSortFilter,
    selectedCategory,
    setSelectedCategory,
    showLoadMore,
    sortBy,
    setSortBy,
    setPage,
    page,
    allOptions,
    categoryOptions,
    sortOptions,
  };
};
